export default function WeekendRetreat() {
  return <section data-section-id="226518" id="operational-footprint-overview" className="relative w-full min-h-[80vh] flex items-center justify-center overflow-hidden bg-background text-foreground">
      {}
      <div role="img" aria-label="ABCO South Electrical Construction and Design ABCO South Electric NC – North Carolina SC – South Carolina VA – Virginia ABCO Electric Chicago IL – Illinois IA – Iowa IN – Indiana WI – Wisconsin NE – Nebraska ABCO West Electric AZ – Arizona" className="absolute inset-0 bg-cover bg-center bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1650264/img/industrial_network_map_overlay.png)] rounded-lg border border-border" />

      {}
      <div className="absolute inset-0 bg-background/60" />

      {}
      <div className="relative z-10 flex flex-col items-center justify-center text-center px-4 sm:px-6 lg:px-8 max-w-5xl mx-auto py-32 md:py-32">
        <h2 className="font-default text-5xl md:text-6xl lg:text-7xl leading-tight text-black mb-6 drop-shadow-none">
          Operational Footprint
        </h2>
        
        <p className="font-sans text-lg md:text-xl text-black mb-10 max-w-2xl drop-shadow-none">
          Our strategic infrastructure spans nine licensed states, ensuring seamless delivery and operational excellence across the nation.
        </p>
      </div>

      {}
      <div className="absolute bottom-0 left-0 right-0 h-32 bg-gradient-to-t from-background/90 to-transparent backdrop-blur-sm pointer-events-none" />
    </section>;
}